/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { get } from "../../../http/shared/methods/get";
import { isAuth, getToken } from "../../../auth/shared/utils/auth";

export type Department = {
  id: number;
  name: string;
  isDeleted: boolean;
};

export enum DictionaryError {
  Network,
  Server,
  InvalidCredentials,
  NotVerified,
}

export enum RequestStatus {
  None,
  Pending,
  Success,
  Fail,
}

export class DictionariesService {
  private _departmentsUrl: string;
  private _departments$ = new BehaviorSubject<Department[]>([])
  private _error$ = new Subject<DictionaryError>();
  private _status$ = new BehaviorSubject<RequestStatus>(RequestStatus.None);

  public get error$() {
    return this._error$.asObservable();
  }

  public get departments$() {
      return this._departments$.asObservable()
  }

  public get departments() {
      return this._departments$.value;
  }

  public get status$() {
    return this._status$.asObservable();
  }

  constructor(apiUrl: string) {
    //TODO: fix URL for real backend
    this._departmentsUrl = apiUrl + "/Departments"; 
  }

  async getDepartmentsDictionary() {
    try {
    this._status$.next(RequestStatus.Pending)
      const result = await get(`${this._departmentsUrl}`);
      result.json().then((res) => {
        this._departments$.next(res);
        this._status$.next(RequestStatus.Success)
      });
    } catch (err) {
      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get user info fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }
}
